import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';
import badge from '../assets/images/badge.jpg';
import waybill from '../assets/images/waybill.webp';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-camera',
      title: 'Professional Pictures',
      description: 'High-quality photography services for portraits, events, and professional headshots.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-id-badge',
      title: 'Custom Badges',
      description: 'Professional badge creation for organizations, events, and identification purposes.',
      image: badge
    },
    {
      icon: 'fas fa-tshirt',
      title: 'New Clothing',
      description: 'Quality new polos, shirts, and jeans in various sizes to suit your style.',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-recycle',
      title: 'Second-Hand Clothing',
      description: 'Affordable pre-owned clothing in excellent condition - polos, shirts, and jeans.',
      image: 'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-ruler',
      title: 'Size Consultation',
      description: 'Professional sizing service to ensure the perfect fit for all your clothing needs.',
      image: 'https://images.unsplash.com/photo-1445205170230-053b83016050?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-shipping-fast',
      title: 'Waybill Services',
      description: 'Reliable shipping and delivery services to different parts of Nigeria.',
      image: waybill
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Our Services</h2>
          <p>Quality pictures, badges, clothing, and delivery services to meet all your needs</p>
        </div>
        
        <div className="services-grid grid grid-3">
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              className="service-card card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <motion.div 
                    className="service-icon"
                    whileHover={{ scale: 1.2, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className={service.icon}></i>
                  </motion.div>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;